import React from "react";
import "./signUp.css";
import aero from "../../Images/aero.jpg";
import vssut from "../../Images/vssut.png";
import iiclogo from "../../Images/iic-logo-white.png";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
// import { useFormik } from 'react';
// import { signUpSchema } from "../schemas";

// ****************************************************************************************
import { useForm } from "react-hook-form";
import { object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Loader from "../../Images/Spinner.gif"
// ****************************************************************************************
// const initialValues = {
//   name: "",
//   email: "",
//   phone: "",
//   branch: "",
//   preference_1: "",
//   preference_2: "",
// };

const SignUp = () => {
  // const { handleSubmit } = useFormik({
  //   validationSchema: signUpSchema,
  //   onSubmit: (values, action) => {
  //     console.log(values);
  //     action.resetForm()
  //   },
  // })
  // ****************************************************************************************
  const [loading, setloading] = useState(false);

  const validationSchema = object().shape({
    name: string()
      .required("Name is required")
      .min(3, "Username must be at least 3 characters"),
    email: string()
      .required("Email is required")
      .email("Invalid email address"),
    college: string().required("Enter your school/college"),
    contact: string().required("Enter your phone number"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  // ****************************************************************************************

  // const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
    contact: "",
    college: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    console.log(user);
  };
  // const option1 = (e) => {
  //   setDom1(e.target.value);
  //   console.log(dom1);
  // };
  // const option2 = (e) => {
  //   setDom2(e.target.value);
  //   console.log(dom2);
  // };

  // const Login = () => {
  //   const gettoken = window.localStorage.getItem("userToken");
  //   console.log(gettoken);
  //   if (gettoken) window.location.href = "./ProfilePage";
  //   else window.location.href = "./signInPage";
  // };

  const postRegister = async (e) => {
    // e.preventDefault();

 // ********************************************************************************************
 setloading(true);
 // ********************************************************************************************

    localStorage.clear();
    // let userData = [];
    const { name, email, contact, college} = user;
        //https://iic-induction-2023.onrender.com
    const res = await fetch("https://aerovantage-backend.onrender.com/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'Accept':"application/json"
      },
      body: JSON.stringify({
        name,
        email,
        contact,
        college,
      }),
    });

    const data = await res.json();


    // ********************************************************************************************
    setloading(false);
    // ********************************************************************************************

    console.log(data.message);
    if (data.message === "Attendee registered") {
      alert("You have been registered for webinar!");
      alert("Confirmation email has been sent to you. Kindly check it.");
    } else if (data.message === "Email already registered") {
      alert("You have already registered with this email.");
      // navigate("/signInPage");
    } else alert(data.message);
    // alert(`${data.message}`);
    // if (data.status === 201) {
    //   navigate("/signInPage");
    // }
    // console.log(data);
    // console.log(dom1);
    // console.log(dom2);
    // console.log(password)
    // console.log(data);
    // if (data.status == "ok") {
    //   alert(`Login Successful`);
    //   window.localStorage.setItem("token", data.data);
    //   window.localStorage.setItem("email", email);
    //   window.localStorage.setItem("site", "freelancer");
    //   history.push("/createWorkspace");
    //   window.location.href = "./createWorkspace"
    // }
    // else if (data.status == "error")
    //   alert(data.message);
    // else alert("error logging in!");
  };
  return (
    <>
     {loading && <div className="loader d-flex"><img src={Loader} alt="" /></div>}
      <div className="signUp-page-container d-flex">
       
        <div className="signUp-page-wrapper">
          <div className="signUp-page-img">
            <img src={aero} alt="form-img" />
          </div>
          <form onSubmit={handleSubmit(postRegister)} className="signUp-form">
            <div className="logoup d-flex">
              <div className="logo-img"><img src={vssut} alt="vssut-logo"></img></div>
              <div><h2>Drone Dynamics<br /> Webinar</h2></div>
              <div className="logo-img iic-logo"><img src={iiclogo} alt="iic-logo"></img></div>
            </div>
              
            <div className="changef">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                {...register("name")}
                name="name"
                id="Name"
                value={user.name}
                onChange={handleInput}
                placeholder="Enter your Name"
                autoComplete="off"
              />
              {errors.name && (
                <p className="error-message">{errors.name.message}</p>
              )}
            </div>
            <div>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                {...register("email")}
                name="email"
                value={user.email}
                id="email"
                onChange={handleInput}
                placeholder="Enter your Email"
                autoComplete="off"
              />
              {errors.email && (
                <p className="error-message">{errors.email.message}</p>
              )}
            </div>
            <div>
              <label htmlFor="Phone Number">Phone-Number</label>
              <input
                type="number"
                {...register("contact")}
                name="contact"
                value={user.contact}
                id="Phone-Number"
                onChange={handleInput}
                placeholder="Phone Number"
                autoComplete="off"
              />
              {errors.contact && (
                <p className="error-message">{errors.contact.message}</p>
              )}
            </div>
            {/* <div className="grid-two-col">
              <div>
                <label htmlFor="Phone Number">Phone-Number</label>
                <input
                  type="number"
                  {...register("contact")}
                  name="contact"
                  onChange={handleInput}
                  value={user.contact}
                  id="Phone-Number"
                  placeholder="Phone Number"
                  autoComplete="off"
                />
                {errors.contact && (
                  <p className="error-message">{errors.contact.message}</p>
                )}
              </div>
              <div>
                <label htmlFor="regdno">Registration No:</label>
                <input
                  type="number"
                  {...register("regdno")}
                  name="regdno"
                  onChange={handleInput}
                  value={user.regdno}
                  id="Phone-Number"
                  placeholder="Registration Number"
                  autoComplete="off"
                />
                {errors.regdno && (
                  <p className="error-message">{errors.regdno.message}</p>
                )}
              </div>
            </div> */}
            <div>
              <label htmlFor="college">Institution Name</label>
              <input
                type="text"
                {...register("college")}
                name="college"
                id="college"
                onChange={handleInput}
                value={user.college}
                placeholder="Enter your Institution"
                autoComplete="off"
              />
              {errors.college && (
                <p className="error-message">{errors.college.message}</p>
              )}
            </div>
            {/* <div className="phone-container grid-two-col">
              <label htmlFor="regdno">Registration No:</label>
              <input type="number" name="regdno" onChange={handleInput} value={user.regdno} id="Phone-Number" placeholder="Registration Number" autoComplete="off" />
              {errors.regdno && (
            <p className="error-message">{errors.regdno.message}</p>
          )}
            </div> */}

            <button className="sign-up-btn" type="submit" value="Register" >Register</button>
          </form>
        </div>
        <div className="tagline"></div>
      </div>
    </>
  );
};

export default SignUp;
